"use client"

import { useTr } from "../../../lib/use-tr"
import { NextStepCell } from "../../contacts/_components/next-step-cell"

import type { Lead } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

const PILOT_BAR_T = {
  openCompany: {
    FR: "Ouvrir la fiche entreprise : tâches et prochaine étape",
    EN: "Open the company: tasks and next step",
  },
  showSteps: {
    FR: "Voir les étapes du contact",
    EN: "Show the contact's steps",
  },
}

// The next thing owed on a lead, the body of the card's "Tasks" band. Only reads that prime the next step (the
// campaign listing, a lead read on its own) carry `pilot`, so the bar renders
// nowhere else rather than show a "nothing owed" it cannot vouch for. With an
// `onActivate` it is a button (open the company, or jump to the steps when the
// company is already open); without one it is a plain row.
export function LeadPilotBar({
  lead,
  onActivate,
  activation = "openCompany",
}: {
  lead: Lead
  onActivate?: () => void
  // What the click does, for its accessible name.
  activation?: "openCompany" | "showSteps"
}) {
  const tr = useTr(PILOT_BAR_T)
  if (!lead.pilot) return null
  if (!onActivate) {
    return (
      <div className="flex min-w-0 py-1 contain-inline-size">
        <NextStepCell step={lead.next_step} />
      </div>
    )
  }
  return (
    <div className="flex">
      <button
        type="button"
        onClick={onActivate}
        aria-label={tr(activation)}
        title={tr(activation)}
        // Sized by the card, never by its own text: the cards sit in a
        // scroll area that grows to its widest content, so a long step
        // label would otherwise push every card past a phone's width.
        // The negative margin lines the step text up with the card content
        // while the hover fill keeps its padding.
        className="hover:bg-accent focus-visible:ring-ring -mx-1.5 min-w-0 flex-1 rounded-md px-1.5 py-1 text-left contain-inline-size outline-none focus-visible:ring-2"
      >
        <NextStepCell step={lead.next_step} />
      </button>
    </div>
  )
}
